import React from "react";
import { MarketingLayout } from "../../components/marketing/MarketingLayout";
import { TwoCol } from "../../components/marketing/TwoCol";

export default function Research() {
  return (
    <MarketingLayout
      active="research"
      title="Research. Crowther."
      description="Applied research on entity resolution, reasoning over knowledge graphs, and specialist model performance."
    >
      <TwoCol
        id="mkt-research"
        label="Research"
        title="Research."
        lede="Applied, not academic. We publish what we can defend."
      >
        <div className="mkt-rows">
          <div className="mkt-row" data-testid="mkt-research-benchmark">
            <div className="mkt-row-name">DeepResearch Bench</div>
            <div>
              <div className="mkt-row-desc">
                An agent built on Atom placed second overall on DeepResearch Bench, scoring 53.70, and first on insight at 57.2, ahead of Gemini 2.5 Pro.
              </div>
              <div className="mkt-meta" style={{ marginTop: 8 }}>Benchmark result</div>
            </div>
          </div>
        </div>
        <p className="mkt-body" style={{ marginTop: 40, maxWidth: "60ch" }}>
          Our durable technical focus is entity resolution and reasoning over knowledge graphs. Retrieval finds documents that mention a name; resolution reveals the single entity behind them, and reasoning runs over the relationships between resolved entities. The work that follows lives inside that surface.
        </p>
      </TwoCol>
    </MarketingLayout>
  );
}
